export const SITE_URL = "https://mynavodayans.in";

// Office address supplied in the owner's Google Business Profile screenshots.
export const BUSINESS = {
  name: "Mynavodayans Online Services Private Limited",
  phone: "+919424706212",
  address: "Ward 31, beside Sanyasi Baba, Jawhar Nagar, Satna, Madhya Pradesh 485001",
  street: "Ward 31, beside Sanyasi Baba, Jawhar Nagar",
  city: "Satna",
  region: "Madhya Pradesh",
  postalCode: "485001",
  country: "IN",
  logo: SITE_URL + "/assets/mynavodayans-logo.png",
  maps: "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent("Mynavodayans Online Services Private Limited, Ward 31, beside Sanyasi Baba, Jawhar Nagar, Satna, Madhya Pradesh 485001"),
  review: "https://g.page/r/CbpnKnHRzF7qEBI/review",
};

export function businessSchema(settings = {}) {
  return {
    "@context": "https://schema.org",
    "@type": ["Organization", "LocalBusiness"],
    "@id": SITE_URL + "/#organization",
    name: settings.company_name || BUSINESS.name,
    url: SITE_URL + "/",
    logo: BUSINESS.logo,
    image: BUSINESS.logo,
    telephone: BUSINESS.phone,
    address: {
      "@type": "PostalAddress",
      streetAddress: settings.address && settings.address !== BUSINESS.address ? settings.address : BUSINESS.street,
      addressLocality: BUSINESS.city,
      addressRegion: BUSINESS.region,
      postalCode: BUSINESS.postalCode,
      addressCountry: BUSINESS.country,
    },
    hasMap: BUSINESS.maps,
    areaServed: [
      { "@type": "Country", name: "India" },
    ],
  };
}

export function compactDescription(value) {
  const text = (value || "").replace(/\s+/g, " ").trim();
  if (text.length <= 160) return text;
  const first = text.match(/^.*?[.!?](?:\s|$)/)?.[0]?.trim();
  if (first && first.length >= 70 && first.length <= 160) return first;
  return text.slice(0, 157).replace(/\s+\S*$/, "") + "…";
}
